import { Box, Flex, Text, Tooltip } from "@mantine/core"

const CallTopInfo = (

  { dateDisplay,
    system,
    callDuration,
    internalUsers,
    externalUsers,
    account
  }
     : 
     { 
        dateDisplay: string, 
        system: string, 
        callDuration: any,
        internalUsers: any[],
        externalUsers: any[],
        account: any
    }
) => {


  return (
    <Box mb="md" w={480} px='sm'>
      <Flex mb="sm">
        <Text mr={5} color="#5A5A5A">Recorded on </Text>
        <Text mr={5} color="#5A5A5A">{dateDisplay} </Text>
        <Text mr={5} color="#5A5A5A">via </Text>
        <Text mr={5} color="#5A5A5A">{system}, </Text>
        <Text color="#5A5A5A">{callDuration} </Text>
      </Flex>
    
      <Text color="#5A5A5A" mb='4px'>Participants:</Text>
      {internalUsers && internalUsers.length > 0 && 
      <Flex>
        {account?.name && 
        <Tooltip label={account?.name}>
          <Text w={116} lineClamp={1}>
            {account?.name}:
          </Text>
        </Tooltip>
        }
    
    
        {internalUsers &&
                        internalUsers?.length > 0 && <Box w={400} mb={8}>
          {internalUsers &&
                        internalUsers?.length > 0 &&
                        internalUsers?.map((user: any, index: number) => (
                          <Box key={index}>
                            {user?.name && <Text mr="3px" color="#5A5A5A">{user?.name || 'N/A'}</Text>}
                            {user?.emailAddress && <Flex>
                              <Text color="#5A5A5A">({user?.emailAddress || 'N/A'})</Text>
                              {index !== internalUsers?.length - 1 && <Text color="#5A5A5A">,</Text>}
                            </Flex>}
                            
                          </Box>
                        ))}{" "}
        </Box>}
      </Flex>}
    
      {/* externalUsers */}
    
      <Flex>
        <Text w={116}>
          {" "}
                      External:
        </Text>
        <Box w={400}>
          {externalUsers &&
                        externalUsers?.length > 0 &&
                        externalUsers?.map((user: any, index: number) => (
                          <Box>
                            {user?.name && <Text mr="3px" color="#5A5A5A">{user?.name || 'N/A'}</Text>}
                            {user?.emailAddress && <Flex>
                              <Text color="#5A5A5A"> ({user?.emailAddress || 'N/A'})</Text>
                              {index !== externalUsers?.length - 1 && <Text color="#5A5A5A">,</Text>}
                            </Flex>}
                            
    
                          </Box>
                        ))}{" "}
        </Box>
      </Flex>
    </Box>
  )
}

export default CallTopInfo